<template>
    <div class="mainCon">
      <div class="contbanner standbymain">
        <div class="mainDivWidth flexDiv stanmain">
          <div class="stanLeft wow fadeInLeft animated">
            <div class="scene-Header">
              <div class="flexDiv">
                <div class="stancont">
                  <p class="sceneTitle">购券活动</p> 
                  <p class="backtxt">一份优惠 两笔交易</p>
                </div>
                <p class="explantxt">用户在指定入口参与定额购买优惠券活动，在有效期内至合作商户按规则核销即可</p>
                <div class="startban">
                  <p>推荐指数：</p>
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                  <img src="static/img/activity/start.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="stanRight wow fadeInRight animated">
            <img src="static/img/activity/buyCoupon/bannerpic.png" alt="">
          </div>
        </div>
      </div>
      <div class="conticon">
        <div class="mainDivWidth flexDiv conmains" >
          <div class="ditchList wow zoomIn animated" v-for="conlis in conticonList" @click="changeanchorId(conlis.id)">
            <img :src="conlis.pic" alt="">
            <p>{{conlis.title}}</p>
          </div>
        </div>
      </div>
      <section id="recommend">
        <div class="mainDivWidth">
          <h3 class="sectionTitle">推荐理由</h3>
          <div class="recommend flexDiv">
            <div v-for="rec in recomList" class="recomlist">
              <img :src="rec.icons" alt="">
              <div class="recomtxt">
                <p class="smallfont">{{rec.title}}</p>
                <span>{{rec.cont}}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="contbg" id="contbg">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">活动数据</h3>
          <div class="flexDiv actDatamain">
            <div class="activedata" v-for="actl in activedatas">
              <p>{{actl.nums}}</p>
              <span>{{actl.explain}}</span>
            </div>
          </div>
        </div>
      </section>
      <section id="flowPath">
        <div class="mainDivWidth">
          <h3 class="sectionTitle">活动流程</h3>
          <div class="flexDiv flowpics">
            <img src="static/img/activity/buyCoupon/flow/flow01.png" alt="">
            <img class="direct" src="static/img/activity/dirsmall.png" alt="">
            <img src="static/img/activity/buyCoupon/flow/flow02.png" alt="">
            <img class="direct" src="static/img/activity/dirsmall.png" alt="">
            <img src="static/img/activity/buyCoupon/flow/flow03.png" alt="">
            <img class="direct" src="static/img/activity/dirsmall.png" alt="">
            <img src="static/img/activity/buyCoupon/flow/flow04.png" alt="">
            <img class="direct" src="static/img/activity/dirsmall.png" alt="">
            <img src="static/img/activity/buyCoupon/flow/flow05.png" alt="">
            <img class="direct" src="static/img/activity/dirsmall.png" alt="">
            <img src="static/img/activity/buyCoupon/flow/flow06.png" alt="">
          </div>
        </div>
      </section>
      <section id="actCase">
        <div class="casebg">
          <div class="mainDivWidth">
            <h3 class="sectionTitle whiteText">活动案例</h3>
            <div class="flexDiv casecont">
              <img class="wow rotateInDownRight animated" src="static/img/activity/buyCoupon/casepic/case01.png" alt="">
              <img class="wow rotateInDownRight animated" src="static/img/activity/buyCoupon/casepic/case02.png" alt="">
              <img class="wow rotateInDownRight animated" src="static/img/activity/buyCoupon/casepic/case03.png" alt="">
            </div>
          </div>
        </div>
      </section>
     
      <section>
        <div class="mainDivWidth">
          <h3 class="sectionTitle">我们还可以做到</h3>
          <div class="flexDiv maskcont">
            <div class="maskban wow bounceIn animated" v-for="mas in maskList">
              <img :src="mas.pics" alt="">
              <p>{{mas.title}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import { WOW } from "wowjs";
  export default {
    name: 'buycoupon',
    data:function(){
      return {
        conticonList:[
          {
            id:"recommend",
            title:"推荐理由",
            pic:"static/img/activity/standby/icon-2/logo01.png"
          },
          {
            id:"contbg",
            title:"活动数据",
            pic:"static/img/activity/standby/icon-2/logo02.png"
          },
          {
            id:"flowPath",
            title:"活动流程",
            pic:"static/img/activity/standby/icon-2/logo03.png"
          },
          {
            id:"actCase",
            title:"活动案例",
            pic:"static/img/activity/standby/icon-2/logo04.png"
          },
        ],
        recomList: [
          {
            icons:"static/img/activity/buyCoupon/icon-1/logo01.png",
            title:"一份优惠  两笔交易",
            cont:"用户购券需支付，购买后二次核销带动多笔交易"
          },
          {
            icons:"static/img/activity/standby/icon-1/actstan02.png",
            title:"自主购买促核销",
            cont:"用户有购券成本，核销率99%；提高交易增加留存"
          },
          {
            icons:"static/img/activity/buyCoupon/icon-1/logo03.png",
            title:"提升(银行)卡片激活率",
            cont:"购券需要用户提前绑卡才能参与优惠购券"
          },
          {
            icons:"static/img/activity/buyCoupon/icon-1/logo04.png",
            title:"产品配置稳定快速",
            cont:"购券活动已产品化，后台配置完成方便快捷；无需代码程序，降低人工风险"
          }
        ],
        activedatas:[
          {
            nums:"100个+", 
            explain:"活动数量"
          },
          {
            nums:"320万人次+", 
            explain:"参与人数"
          },
          {
            nums:"9900万元+", 
            explain:"优惠金额"
          },
          {
            nums:"43000万元+", 
            explain:"交易金额"
          }
        ],
        maskList:[
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic01.png",
            title:"指定白名单优惠",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic02.png",
            title:"手机号归属地优惠(手机号/银行卡号)",
          }, 
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic03.png",
            title:"指定信用卡/借记卡，卡级别用户优惠",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic04.png",
            title:"仅限自有渠道（公众号/APP）购买核销—用户留存",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic05.png",
            title:"指定品牌商户可享优惠—二次精准营销（如银行+油企合资）",
          }
        ]
      }
    },
    mounted() {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: false
      });
      wow.init();
    },
    methods: {
      changeanchorId(id) {
        $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
        this.backTop = true;
        return false; // 返回false可以避免在原链接后加上#
      },
    }
  }
  </script>
  <style scoped lang="scss">
    @import "../../assets/css/activityClass/actBuyCoupon";
  </style>
  


// WEBPACK FOOTER //
// src/pages/activityTypePage/activity4-buyCoupon.vue